module.exports = __webpack_public_path__ + "d28c6ac49b2568528c4751101e7b3a50.png";